import { render, staticRenderFns } from "./Falta.vue?vue&type=template&id=8435480c&lang=pug&"
import script from "./Falta.vue?vue&type=script&lang=js&"
export * from "./Falta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports